export default __webpack_public_path__ + "static/media/rtl_reports_ipad.82e917f1.png";